import { paths } from '@/shared/config/paths';

// 정렬
export const orderByOptions = [
	{ title: '최신 순', value: 'desc' },
	{ title: '오래된 순', value: 'asc' },
];

// 사용/미사용
export const usageStatusOptions = [
	{ title: '사용', value: 1 },
	{ title: '미사용', value: 0 },
];

// 상단 GNB 메뉴
export const headerMenu = [
	{ dataText: '대시보드', pathname: paths.dashboard.path },
	{ dataText: '콘텐츠', pathname: paths.operation.news.list.path },
	{ dataText: '파트너', pathname: paths.partner.join.list.path },
	{ dataText: '이벤트', pathname: paths.event.qr.list.path },
];
